export const USER_ROLES={
    USER:"user",
    ADMIN:"admin"
}
export const cRegion = "ap-south-1";
export const TOKEN = "access-token"
export const REFRESH_TOKEN = "refresh-token"
export const USER_ID = "user_id"
export const USER_GROUPS = "user_groups"
export const USER_DATA = "user_data"
export const PERMISSIONS = "user_permissions"
export const drawerWidth = 300
export const socialPostAllowedConstraints = {
    fbMaxImageFileCount: 10,
    fbMaxVideoFileSizeInTotal: 500, // in MB
    fbMaxImageFileSizeInTotal: 30, // in MB
    inMaxImageFileCount: 20,
    inMaxVideoFileSizeInTotal: 512, // in MB
    inMaxImageFileSizeInTotal: 5, // in MB
    twMaxImageFileCount: 4,
    twMaxVideoFileSizeInTotal: 512, // in MB
    twMaxImageFileSizeInTotal: 5, // in MB
    twMaxVideoFileDuration: 140, // in seconds
    maxVideoFileCount: 1,
    fbMaxCharacterCount: 63206,
    inMaxCharacterCount: 3000,
    twMaxCharacterCount: 280,
};